import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { QadderLogo } from './Logo';

const SECTIONS = [
  {
    id: 'qudurat', icon: '🧠', color: '#7c6df8', label: 'قدرات',
    subjects: ['كمي', 'لفظي'],
    subsections: [
      { id: 'كمي',  icon: '🔢', color: '#3b82f6', label: 'كمي' },
      { id: 'لفظي', icon: '📖', color: '#7c6df8', label: 'لفظي' },
    ],
  },
  {
    id: 'tahsili', icon: '🎓', color: '#10b981', label: 'تحصيلي',
    subjects: ['رياضيات', 'فيزياء', 'كيمياء', 'أحياء'],
    subsections: [
      { id: 'رياضيات', icon: '📐', color: '#3b82f6', label: 'رياضيات' },
      { id: 'فيزياء',  icon: '⚡', color: '#f59e0b', label: 'فيزياء' },
      { id: 'كيمياء',  icon: '⚗️', color: '#10b981', label: 'كيمياء' },
      { id: 'أحياء',   icon: '🧬', color: '#ec4899', label: 'أحياء' },
    ],
  },
];

export default function TajamuatScreen({ onSelect, onBack }) {
  const [counts, setCounts] = useState({});
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    const load = async () => {
      const c = {};
      const allSubjects = SECTIONS.flatMap(s => [...s.subjects, ...s.subsections.map(sub => sub.id)]);
      const unique = [...new Set(allSubjects)];
      for (const subj of unique) {
        const { count } = await supabase
          .from('questions')
          .select('count', { count: 'exact', head: true })
          .eq('subject', subj)
          .eq('is_active', true);
        c[subj] = count || 0;
      }
      setCounts(c);
    };
    load();
  }, []);

  const sectionCount = (section) =>
    section.subjects.reduce((sum, s) => sum + (counts[s] || 0), 0);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg-page)',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      padding: '32px 20px', fontFamily: 'Tajawal,sans-serif', direction: 'rtl',
    }}>
      <div style={{ width: '100%', maxWidth: 440 }}>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
          <QadderLogo onHome={onBack} size={32} />
          <button onClick={onBack} style={{
            background: 'var(--bg-card)', border: '1px solid var(--border)',
            borderRadius: 10, padding: '7px 14px', color: 'var(--text-secondary)',
            fontSize: 13, cursor: 'pointer',
          }}>← رجوع</button>
        </div>

        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 48, marginBottom: 10 }}>🗂️</div>
          <h2 style={{ color: 'var(--text)', fontSize: 24, fontWeight: 900, margin: '0 0 8px' }}>تجمعات محدث</h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: 14, margin: 0 }}>أسئلة من تجميعات اختبارات حقيقية</p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {SECTIONS.map(section => (
            <div key={section.id}>
              <button
                onClick={() => setExpanded(expanded === section.id ? null : section.id)}
                style={{
                  width: '100%', background: `${section.color}12`,
                  border: `2px solid ${section.color}${expanded === section.id ? '80' : '40'}`,
                  borderRadius: 20, padding: '20px 24px', cursor: 'pointer',
                  fontFamily: 'Tajawal,sans-serif',
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  transition: 'all 0.2s',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                  <span style={{ fontSize: 36 }}>{section.icon}</span>
                  <div>
                    <div style={{ color: 'var(--text)', fontWeight: 800, fontSize: 18 }}>{section.label}</div>
                    <div style={{ color: section.color, fontSize: 12, fontWeight: 700, background: `${section.color}20`, borderRadius: 20, padding: '2px 10px', display: 'inline-block', marginTop: 4 }}>
                      {sectionCount(section).toLocaleString()} سؤال
                    </div>
                  </div>
                </div>
                <span style={{ color: section.color, fontSize: 20 }}>{expanded === section.id ? '▲' : '▼'}</span>
              </button>

              {expanded === section.id && (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginTop: 10, paddingRight: 8 }}>
                  <button
                    onClick={() => onSelect({ mode: 'tajamuat', subject: section.subjects[0], subjects: section.subjects })}
                    style={{ gridColumn: 'span 2', background: `${section.color}15`, border: `2px solid ${section.color}50`, borderRadius: 14, padding: '14px', cursor: 'pointer', fontFamily: 'Tajawal,sans-serif', color: section.color, fontWeight: 700, fontSize: 15 }}
                  >
                    📚 الكل — {sectionCount(section).toLocaleString()} سؤال
                  </button>
                  {section.subsections.map(sub => (
                    <button
                      key={sub.id}
                      onClick={() => onSelect({ mode: 'tajamuat', subject: sub.id, subjects: [sub.id] })}
                      style={{ background: `${sub.color}12`, border: `2px solid ${sub.color}40`, borderRadius: 14, padding: '16px 12px', cursor: 'pointer', textAlign: 'center', fontFamily: 'Tajawal,sans-serif', transition: 'all 0.2s' }}
                    >
                      <div style={{ fontSize: 28, marginBottom: 6 }}>{sub.icon}</div>
                      <div style={{ color: 'var(--text)', fontWeight: 700, fontSize: 14 }}>{sub.label}</div>
                      <div style={{ color: sub.color, fontSize: 11, fontWeight: 700, background: `${sub.color}20`, borderRadius: 20, padding: '2px 8px', display: 'inline-block', marginTop: 4 }}>
                        {(counts[sub.id] || 0).toLocaleString()} سؤال
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
